export enum TypeIncome {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  YEARLY_RANGE = 'YEARLY_RANGE',
  YEARLY_FORECAST = 'YEARLY_FORECAST',
  PREVIOUS_ANNUAL = 'PREVIOUS_ANNUAL',
  CURRENT_YEAR = 'CURRENT_YEAR'
}
